var map = {
	"./skin1/edit_clothes_no_highlight@3x.png": "3299",
	"./skin2/edit_clothes_no_highlight@3x.png": "a192",
	"./skin3/edit_clothes_no_highlight@3x.png": "445a",
	"./skin4/edit_clothes_no_highlight@3x.png": "431b",
	"./skin5/edit_clothes_no_highlight@3x.png": "e1a6",
	"./skin6/edit_clothes_no_highlight@3x.png": "04dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a39";